import './socialhousevodka/style';
import FormStructure from './socialhousevodka/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/includes.js